import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-354a640a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubList" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "display-2 mb-4",
  style: {"text-align":"center"}
}, "Karantæne", -1))
const _hoisted_3 = { class: "va-table-responsive" }
const _hoisted_4 = {
  class: "va-table va-table--striped membersTable",
  style: {"width":"100%"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "center",
  hidden: ""
}, "ID", -1))
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_11 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_12 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_14 = { class: "selectPageSize" }
const _hoisted_15 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","align-items":"center","height":"150px","text-align":"center","font-size":"18px","font-weight":"bold"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.medlemers?.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_5,
                  _createElementVNode("th", {
                    class: "sorting",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('navn')))
                  }, "Navn"),
                  _createElementVNode("th", {
                    class: "sorting",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.columnSort('karantaene')))
                  }, "Karantæne")
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medlemers, (medlem, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: Number(medlem.id)
                  }, [
                    _createElementVNode("td", {
                      id: 'memberstable-row' + (index+1),
                      class: "center",
                      hidden: ""
                    }, _toDisplayString(medlem.id), 9, _hoisted_6),
                    _createElementVNode("td", {
                      id: 'memberstable-row' + (index+1)
                    }, _toDisplayString(medlem.user_id.firstname) + " " + _toDisplayString(medlem.user_id.lastname), 9, _hoisted_7),
                    _createElementVNode("td", {
                      id: 'memberstable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_icon, {
                        size: "large",
                        name: (_ctx.testActiveQuarantine(medlem.medlem_karantaene_dato, medlem.medlem_karantaene_slutdato) ? 'no_accounts' : ''),
                        color: "danger"
                      }, null, 8, ["name"]),
                      _createTextVNode(_toDisplayString((medlem.medlem_karantaene_dato === null ? '' : _ctx.toDanishDateString(medlem.medlem_karantaene_dato) + ' til ') + (medlem.medlem_karantaene_slutdato === null ? '' : _ctx.toDanishDateString(medlem.medlem_karantaene_slutdato))), 1)
                    ], 8, _hoisted_8)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_va_button, {
                icon: "first_page",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jumpToPage(1)))
              }),
              _createVNode(_component_va_button, {
                icon: "keyboard_double_arrow_left",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.turnToNewPage(-5)))
              }),
              _createVNode(_component_va_button, {
                icon: "chevron_left",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.turnToNewPage(-1)))
              }),
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentPage) = $event)),
                type: "number",
                onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.jumpToPage(_ctx.currentPage)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.currentPage]
              ]),
              (_ctx.totalNumberOfPages === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_12, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
              _createVNode(_component_va_button, {
                icon: "chevron_right",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.turnToNewPage(1)))
              }),
              _createVNode(_component_va_button, {
                icon: "keyboard_double_arrow_right",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.turnToNewPage(5)))
              }),
              _createVNode(_component_va_button, {
                icon: "last_page",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.jumpToPage(_ctx.totalNumberOfPages)))
              }),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_va_select, {
                  class: "mr-2",
                  modelValue: _ctx.pageSizeValueString,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
                  options: _ctx.pageSizeOptions,
                  bordered: ""
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, " No Data Found "))
    ])
  ]))
}